import { React } from 'react';
import { toast } from 'react-toastify';

import { Button } from '@trussworks/react-uswds';
import TextInput from '@components/text-input/TextInput';

import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { useForm, FormProvider } from 'react-hook-form';
import { DeveloperAccessService } from '@src/api/services/developer/service';
import { ResponseStatuses } from '@src/utils/enums';

const schema = yup.object().shape({
  originUserEmail: yup.string().required('Field is required'),
  destinationUserEmail: yup.string().required('Field is required'),
});

const defaultValues = {
  originUserEmail: null,
  destinationUserEmail: null,
};

const onInvalid = () => {
  toast.error('Please fill out all required fields!', { autoClose: false });
};

const TransferUserProjects = () => {
  const methods = useForm({
    defaultValues: defaultValues,
    resolver: yupResolver(schema),
    mode: 'onBlur',
  });

  const { setValue, handleSubmit } = methods;

  const onSubmit = async ({ originUserEmail, destinationUserEmail }) => {
    try {
      const response = await DeveloperAccessService.transferUserProjects(originUserEmail, destinationUserEmail);

      if (
        response &&
        response.status !== ResponseStatuses.Failed &&
        response.status !== ResponseStatuses.SuccessNoResult
      ) {
        const blob = new Blob([response], { type: 'text/csv' });
        const fileName = 'transferredProjects.csv';

        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);

        toast.success('Successfully transferred user projects', { autoClose: false });
      } else if (response && response.status === ResponseStatuses.SuccessNoResult) {
        toast.warning(response.msg, { autoClose: false });
      }

      // Reset values
      setValue('originUserEmail', null);
      setValue('destinationUserEmail', null);
    } catch (error) {
      toast.error(error.message, { autoClose: false });
    }
  };

  return (
    <FormProvider {...methods}>
      <div className='pdf-input-container'>
        <div>
          <TextInput className='pdf-input' name='originUserEmail' label='Origin User Email' required />
        </div>
        <div>
          <TextInput className='pdf-input' name='destinationUserEmail' label='Destination User Email' required />
        </div>
      </div>
      <div>
        <Button
          className='dev-dashboard-btn'
          title='Transfer Projects'
          size='small'
          onClick={handleSubmit(onSubmit, onInvalid)}
        >
          Transfer Projects
        </Button>
      </div>
    </FormProvider>
  );
};

export default TransferUserProjects;
